// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoRse[data-v-ec87bac0]{position:absolute;top:2.5%;left:2.5%;z-index:1;width:42%;height:auto}@media(min-width:768px){.logoRse[data-v-ec87bac0]{top:.625rem;left:calc(7.5% + .625rem);width:25%}}.flag-name[data-v-ec87bac0]{font-size:.75rem;font-weight:600;color:#54a39d}.flag-name.sales-price[data-v-ec87bac0]{font-size:14px;font-size:.875rem}@media(min-width:768px){.flag-name.sales-price[data-v-ec87bac0]{font-size:16px;font-size:1rem}}p[data-v-ec87bac0]{margin:0}", ""]);
// Exports
module.exports = exports;
